export const URL_PATH_DRILLDOWN_EXPLORATION_VIEWER = '/drilldown-exploration'
export const SEARCH_PARAM_EXPLORATION_ID = 'exploration'
